import { Database } from '@diamond/api/database';
import { Kysely, sql } from 'kysely';

export async function deteleDuplicateGroupedPromos(
  db: Kysely<Database>
): Promise<void> {
  const dupeEntrySubquery = db
    .selectFrom('grouped_promo_codes as gpc')
    .selectAll('gpc')
    .select([
      sql<number>`rank() over (partition by promo_code order by created_at desc)`.as(
        'dest_rank'
      ),
    ])
    .as('gpci');

  const dupeEntry = await db
    .selectFrom(dupeEntrySubquery)
    .selectAll('gpci')
    .where('gpci.dest_rank', '>', 1)
    .execute();

  for (const dupe of dupeEntry) {
    await db
      .deleteFrom('grouped_promo_codes')
      .where('group_id', '=', dupe['group_id'])
      .where('promo_code', '=', dupe['promo_code'])
      .execute();
  }
}

export const deleteDuplicateGroupedPromos = deteleDuplicateGroupedPromos;
